export enum TokenTypes {
  Form_Editor = 'Form Editor',
  Form_Signatory = 'Form Signatory',
  Form_Complete = 'Form Complete',
  Offer_Iteration = 'Offer Iteration',
  FORM_PREVIEW = 'Form Preview',
}
